import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DatePicker } from 'office-ui-fabric-react';
// import { useSelector } from 'react-redux';
// import { SelectAsOfSmartDate, DateRange } from 'components/common/datePicker';
import InformationIcon from 'components/common/informationIcon/InformationIcon';
// import { getInputNodeData } from 'utils/inputFormUtil';
// import DropDownAutoComplete from 'components/common/dropDown/DropDownAutoComplete';
// import ExcelCell from 'components/common/excel/ExcelCell';
// import ExcelCommonTexts from 'components/common/excel/ExcelCellText';
import { formatDate } from 'utils/dateUtil';
// import { FEE_CATEGORY } from 'containers/phoenix/data/PhoenixServiceIO';
import { CellIdSheetName } from 'containers/phoenix/components/CellIdSheetName';
import { PhoenixServices } from 'containers/phoenix/services/PhoenixServices';
import {
	FEE_CATEGORY,
	WORKSPACE_TYPE,
	ANALYSIS_LEVELS,
	TEMPLATES,
	HIERARCHY_LEVELS_INCLUDE,
	FREQUENCY_OPTIONS,
} from 'containers/phoenix/data/DropDownOptions';
import {
	fetchAccounts,
	fetchClients,
	fetchHierarchies,
	fetchBenchmarks,
	setShowLoader,
} from 'containers/phoenix/redux/PhoenixActions';

const defaultBenchmarkOption = {
	benchmarkBusinessID: 'None',
	benchmarkUsage: 'None',
	key: 'None',
	text: 'None',
};

const ConfigureInputsStep = () => {
	const dispatch = useDispatch();
	const clients = useSelector(state => state.data.phoenixReducers.clients);
	const accounts = useSelector(state => state.data.phoenixReducers.accounts);
	const hierarchies = useSelector(
		state => state.data.phoenixReducers.hierarchies,
	);
	const benchmarks = useSelector(
		state => state.data.phoenixReducers.benchmarks,
	);
	const inputData = useSelector(
		state => state.data.phoenixReducers.inputData,
	);
	const workspaceType = useSelector(
		state => state.data.phoenixReducers.inputData?.workspaceType,
	);
	const createNewDataSet = useSelector(state => state.data.createNewDataSet);
	const token = useSelector(state => state.data.phoenixReducers.token);
	const selectedDataset = useSelector(state => state.data.phoenixReducers.selectedDataset);
	const onRenderLabel = props => {
		const { label, required, tooltipMessage } = props;
		return (
			<InformationIcon
				labelId={label}
				label={label}
				tooltipMessage={tooltipMessage}
				mandatory={required}
			/>
		);
	};

	// NOTE: below method make api call to fetch benchmark on account change
	const fetchBenchmarkOnAccChange = async accountBID => {
		const benchmarkRes = await PhoenixServices.getBenchmarks(
			accountBID,
			token,
		);
		const benchmarkData = benchmarkRes?.data?.data.filter(
			(a, i) =>
				benchmarkRes?.data?.data.findIndex(
					s => a.benchmarkUsage === s.benchmarkUsage,
				) === i,
		);
		dispatch(fetchBenchmarks([defaultBenchmarkOption, ...benchmarkData]));
	};

	// NOTE: below method make api call to fetch account and account-group on client change
	const fetchAccountGroupOnClientChange = async sponsorCode => {
		dispatch(setShowLoader(true));
		const accountResponse = await PhoenixServices.getAccounts(
			sponsorCode,
			token,
		);
		const accountGroupRes = await PhoenixServices.getHierarchies(
			sponsorCode,
			token,
		);
		dispatch(fetchAccounts(accountResponse?.data?.data));
		dispatch(fetchHierarchies(accountGroupRes?.data?.data));
		fetchBenchmarkOnAccChange(
			accountResponse?.data?.data[0]?.accountBusinessID,
		);
		dispatch(setShowLoader(false));
	};

	const onChangeHandler = (e, option) => {
		// NOTE: if selected analysis level as CG then setting default benchmark option
		if (option.key === 'CustomGroup') {
			dispatch(fetchBenchmarks([defaultBenchmarkOption]));
			dispatch({
				type: 'UPDATE_BENCHMARK',
				key: 'benchmark',
				payload: defaultBenchmarkOption,
			});
		}
		if (e.target.id === 'client') {
			fetchAccountGroupOnClientChange(option.SponsorCode);
		}
		// NOTE: On change of analysis level from CG to Account we have to fetch and reset benchmarks
		if (inputData?.analysisLevel?.key !== 'CustomGroup' && e.target.id === 'accountId' || (e.target.id === 'analysisLevel' && option.key === 'Account')) {
			const accBid = option.accountBusinessID || inputData.accountId[0]?.accountBusinessID;
			fetchBenchmarkOnAccChange(accBid);
		}
		dispatch({
			type: `UPDATE_${e.target.id.toUpperCase()}`,
			key: e.target.id,
			payload: option,
		});
	};

	const onCellSheetChange = (cellId, sheetName) => {
		dispatch({
			type: 'UPDATE_CELL_SHEET',
			payload: {
				cellId,
				sheetName,
			},
		});
	};

	const showAccountDropdown = () => {
		return (
			inputData?.analysisLevel?.text !== 'Custom Group' &&
			inputData?.analysisLevel?.text !== 'Investment Hierarchy'
		);
	};

	return (
		<div className="ms-Grid out-put-container">
			<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
				<Dropdown
					label="Client"
					id="client"
					name="Client"
					placeholder="Select Client"
					options={clients}
					required
					multiSelect={false}
					errorMessage=""
					onChange={onChangeHandler}
					defaultSelectedKey={inputData?.client?.key || ''}
					value={inputData?.client}
					calloutProps={{ directionalHintFixed: true }}
					tooltipMessage="Select the client for your report."
					onRenderLabel={onRenderLabel}
					disabled={(selectedDataset?.editClicked || selectedDataset?.duplicateClicked) ? true : false}
				/>
			</div>
			<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
				<Dropdown
					label="Workspace Type"
					id="workspaceType"
					name="workspaceType"
					placeholder="Select worksapce type"
					options={WORKSPACE_TYPE}
					required
					multiSelect={false}
					errorMessage=""
					onChange={onChangeHandler}
					defaultSelectedKey={inputData?.workspaceType?.key || ''}
					value={inputData?.workspaceType}
					calloutProps={{ directionalHintFixed: true }}
					tooltipMessage="Select workspace type for your report."
					onRenderLabel={onRenderLabel}
				/>
			</div>
			{workspaceType?.text === 'Rate of Return' ? (
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
					<Dropdown
						label="Analysis Level"
						id="analysisLevel"
						name="analysisLevel"
						placeholder="Select Analysis Level..."
						options={ANALYSIS_LEVELS}
						required
						multiSelect={false}
						errorMessage=""
						onChange={onChangeHandler}
						defaultSelectedKey={inputData?.analysisLevel?.key || ''}
						value={inputData?.analysisLevel}
						calloutProps={{ directionalHintFixed: true }}
						tooltipMessage="Select analysis level for your report."
						onRenderLabel={onRenderLabel}
					/>
				</div>
			) : null
			// (
			// 	<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
			// 		<Dropdown
			// 			label="Template"
			// 			id="template"
			// 			name="template"
			// 			placeholder="Select template"
			// 			options={TEMPLATES}
			// 			required
			// 			multiSelect={false}
			// 			errorMessage=""
			// 			onChange={onChangeHandler}
			// 			defaultSelectedKey={inputData?.template?.key || ''}
			// 			value={inputData?.template}
			// 			calloutProps={{ directionalHintFixed: true }}
			// 			tooltipMessage="Select template for your report."
			// 			onRenderLabel={onRenderLabel}
			// 		/>
			// 	</div>
			// )
			}
			{showAccountDropdown() ? (
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
					<Dropdown
						label="Account ID"
						id="accountId"
						name="Account ID"
						placeholder="Account/Group"
						options={accounts}
						required
						multiSelect={
							inputData?.analysisLevel?.text === 'Custom Group'
						}
						errorMessage=""
						onChange={onChangeHandler}
						defaultSelectedKey={inputData?.accountId?.[0]?.key}
						value={
							inputData?.accountId?.length > 0
								? inputData?.accountId
								: []
						}
						calloutProps={{ directionalHintFixed: true }}
						tooltipMessage="Select the account[s] or group[s] for your report."
						onRenderLabel={onRenderLabel}
					/>
				</div>
			) : null}
			{inputData?.analysisLevel?.text === 'Custom Group' ? (
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
					<Dropdown
						label="Account/Group"
						id="accountId"
						name="Account ID"
						placeholder="Account/Group"
						options={accounts}
						required
						multiSelect={
							inputData?.analysisLevel?.text === 'Custom Group'
						}
						errorMessage=""
						onChange={onChangeHandler}
						defaultSelectedKeys={
							inputData?.accountId?.length > 0
								? inputData?.accountId?.map(i => i.key)
								: []
						}
						value={
							inputData?.accountId?.length > 0
								? inputData?.accountId
								: []
						}
						calloutProps={{ directionalHintFixed: true }}
						tooltipMessage="Select the account[s] or group[s] for your report."
						onRenderLabel={onRenderLabel}
					/>
				</div>
			) : null}
			{workspaceType?.text === 'Rate of Return' &&
			inputData?.analysisLevel?.text === 'Investment Hierarchy' ? (
					<>
						<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
							<Dropdown
								label="Hierarchy"
								id="hierarchy"
								name="hierarchy"
								placeholder="Select Hierachy..."
								options={hierarchies}
								required
								multiSelect={false}
								errorMessage=""
								onChange={onChangeHandler}
								defaultSelectedKey={inputData?.hierarchy?.key || ''}
								value={inputData?.hierarchy}
								calloutProps={{ directionalHintFixed: true }}
								tooltipMessage="Select Hierarchy for your report."
								onRenderLabel={onRenderLabel}
							/>
						</div>
						<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
							<Dropdown
								label="Hierarchy Levels to Include"
								id="hierarchyLevel"
								name="hierarchyLevel"
								placeholder="Select Hierachy Levels to include..."
								options={HIERARCHY_LEVELS_INCLUDE}
								required
								multiSelect={false}
								errorMessage=""
								onChange={onChangeHandler}
								defaultSelectedKey={
								inputData?.hierarchyLevel?.key || ''
								}
								value={inputData?.hierarchyLevel?.text}
								calloutProps={{ directionalHintFixed: true }}
								tooltipMessage="Select Hierarchy Level to include in your report."
								onRenderLabel={onRenderLabel}
							/>
						</div>
					</>
				) : null}
			{createNewDataSet.selectedServiceData.serviceId ===
			'PhoenixTimeSeries' ? (
					<>
						{' '}
						<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
							<InformationIcon
								labelId="as-of-date"
								label="Start Date"
								tooltipMessage="Choose the start date for your report."
								mandatory
							/>
							<DatePicker
								className={{}}
								id="startdate"
								showMonthPickerAsOverlay
								onSelectDate={e => {
									dispatch({
										type: `UPDATE_STARTDATE`,
										key: 'startdate',
										payload: { text: e },
									});
								}}
								allowTextInput
								isMonthPickerVisible
								formatDate={date => formatDate(date, 'mm/dd/yyyy')}
								maxDate={new Date()}
								value={inputData?.startdate?.text}
								placeholder="Start Date"
							/>
							{inputData?.startdate?.text >
						inputData?.enddate?.text ? (
									<p
										style={{
											color: '#a4262c',
											fontSize: '12px',
											fontWeight: '400',
											marginTop: '5px',
											marginBottom: '0px',
										}}
									>
								Start Date cannot be greater than End Date
									</p>
								) : null}
						</div>
						<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
							<InformationIcon
								labelId="as-of-date"
								label="End Date"
								tooltipMessage="Choose the end date for your report."
								mandatory
							/>
							<DatePicker
								className={{}}
								id="enddate"
								showMonthPickerAsOverlay
								onSelectDate={e => {
									dispatch({
										type: `UPDATE_ENDDATE`,
										key: 'enddate',
										payload: { text: e },
									});
									//NOTE: on dataset manager on change reference date (as of date) we need to update the enddate as well
									dispatch({
										type: `UPDATE_REFERANCEDATE`,
										key: 'referancedate',
										payload: { text: e },
									});
								}}
								allowTextInput
								isMonthPickerVisible
								formatDate={date => formatDate(date, 'mm/dd/yyyy')}
								maxDate={new Date()}
								value={inputData?.enddate?.text}
								placeholder="End Date"
							/>
						</div>{' '}
						<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
							<Dropdown
								label="Frequency"
								id="frequency"
								name="frequency"
								placeholder="Select Frequency to include..."
								options={FREQUENCY_OPTIONS}
								required
								multiSelect={false}
								errorMessage=""
								onChange={onChangeHandler}
								defaultSelectedKey={
								inputData?.frequency?.key || ''
								}
								value={inputData?.frequency?.text}
								calloutProps={{ directionalHintFixed: true }}
								tooltipMessage="Select Frequency Level to include in your report."
								onRenderLabel={onRenderLabel}
							/>
						</div>
					</>
				) : (
					<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
						<InformationIcon
							labelId="as-of-date"
							label="As of Date"
							tooltipMessage="Choose the reference date for your report."
							mandatory
						/>
						<DatePicker
							className={{}}
							id="referancedate"
							showMonthPickerAsOverlay
							onSelectDate={e => {
								dispatch({
									type: `UPDATE_REFERANCEDATE`,
									key: 'referancedate',
									payload: { text: e },
								});
							}}
							// isRequired
							// strings={DayPickerStrings}
							allowTextInput
							isMonthPickerVisible
							formatDate={date => formatDate(date, 'mm/dd/yyyy')}
							maxDate={new Date()}
							value={inputData?.referancedate?.text}
							placeholder="As Of Date"
						/>
						{!inputData?.referancedate?.text ? (
							<p
								style={{
									color: '#a4262c',
									fontSize: '12px',
									fontWeight: '400',
									marginTop: '5px',
									marginBottom: '0px',
								}}
							>
							Please select as of date
							</p>
						) : null}
					</div>
				)}
			<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
				<Dropdown
					label="Fee Category"
					id="fee"
					name="fee"
					placeholder="Select Fee Category..."
					options={FEE_CATEGORY}
					required
					multiSelect={false}
					errorMessage=""
					onChange={onChangeHandler}
					defaultSelectedKey={inputData?.fee?.key}
					value={inputData?.fee?.text}
					calloutProps={{ directionalHintFixed: true }}
					tooltipMessage="Select the fee category for your report."
					onRenderLabel={onRenderLabel}
				/>
			</div>
			{(inputData?.analysisLevel?.text !== 'Investment Hierarchy' &&
			inputData?.analysisLevel?.key !== 'CustomGroup') ? (
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
					<Dropdown
						label="Benchmark"
						id="benchmark"
						name="benchmark"
						placeholder="Select Benchmark..."
						options={benchmarks}
						required
						multiSelect={false}
						errorMessage=""
						onChange={onChangeHandler}
						defaultSelectedKey={inputData?.benchmark?.key}
						value={inputData?.benchmark?.text}
						calloutProps={{ directionalHintFixed: true }}
						tooltipMessage="Select benchmark for your report."
						onRenderLabel={onRenderLabel}
					/>
				</div>
			) : null}

			<CellIdSheetName
				cellNumber={inputData?.cellNumber}
				sheetName={inputData?.sheetName}
				onRenderLabel={onRenderLabel}
				onChangeDispatch={onCellSheetChange}
			/>
		</div>
	);
};

export default ConfigureInputsStep;
